/** 若使用者為「維肯員工」時，在公司選擇器中要把「維肯媒體」在公司列表置頂。 */
export const FRONTEND_SYSTEM_STAFF_PRIORITY_COMPANY_UUID = 'cd31e102-a589-4df6-974d-514c71abcce7'

export const CompanySubscriptionDisplayName = {
  Professional: 'Professional',
  Enterprise: 'Enterprise',
  Basic: 'Basic',
  Trial: 'Trial',
  None: 'None'
} as const

export type CompanySubscriptionDisplayName =
  (typeof CompanySubscriptionDisplayName)[keyof typeof CompanySubscriptionDisplayName]
